import { createContext, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../../api/auth';
import type { SessionUser } from './types';

export type AuthContextValue = {
  user: SessionUser | null;
  isLoading: boolean;
  error: Error | null;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

type AuthProviderProps = {
  children: ReactNode;
};

export function AuthProvider({ children }: AuthProviderProps) {
  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: fetchMe,
    retry: false,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

  const value: AuthContextValue = {
    user: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error as Error | null,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
